import Vue from 'vue'
import Router from 'vue-router'
import login from '../pages/login/Login'
import firebase from 'firebase'
import { permissions, defaultRouteFor } from '../utils/permissions'

Vue.use(Router)

// Lê a posição/cargo do afiliado autenticado no Realtime Database.
const getCurrentPosition = async () => {
  const uid = window.uid
  if (!uid) return null
  const snapshot = await firebase
    .database()
    .ref(`affiliates/${uid}/position`)
    .once('value')
  return snapshot.val()
}

// Cria um guard de rota a partir de um predicado de permissão (utils/permissions).
const guard = (canAccess) => async (to, from, next) => {
  try {
    if (!window.uid) {
      next({ name: 'login' })
      return
    }
    const position = await getCurrentPosition()
    if (canAccess(position)) {
      next()
    } else {
      Vue.$toast.error('Acesso restrito.')
      next({ name: defaultRouteFor(position) })
    }
  } catch (error) {
    console.error('Erro ao verificar permissão:', error)
    next({ name: 'login' })
  }
}

const routes = [
  {
    path: '/',
    name: 'index',
    meta: {
      title: 'Entrar',
      public: true
    },
    component: login
  },
  {
    path: '/login/:email?/:password?',
    name: 'login',
    meta: {
      title: 'Entrar',
      public: true
    },
    component: login
  },
  {
    path: '/management/',
    name: 'management',
    meta: {
      title: 'Gestão'
    },
    component: () => import(/* webpackChunkName: "Login" */ '../pages/management/Management'),
    beforeEnter: guard(permissions.management)
  },
  {
    path: '/users/:searchValue?',
    name: 'users',
    meta: {
      title: 'Clientes'
    },
    component: () => import(/* webpackChunkName: "Login" */ '../pages/users/Users'),
    beforeEnter: guard(permissions.users)
  },
  {
    path: '/home/',
    name: 'home',
    meta: {
      title: 'Resumo'
    },
    component: () => import(/* webpackChunkName: "Home" */ '../pages/home/Home'),
    beforeEnter: guard(permissions.home)
  },
  {
    path: '/leads/:searchValue?',
    name: 'leads',
    meta: {
      title: 'Leads'
    },
    component: () => import(/* webpackChunkName: "HotLeads" */ '../pages/hotleads/Leads'),
    beforeEnter: guard(permissions.leads)
  },
  {
    path: '/simulator',
    name: 'simulador',
    meta: {
      title: 'Simulador'
    },
    component: () => import(/* webpackChunkName: "HotLeads" */ '../pages/hotleads/Simulator/SimulatorPlans.vue'),
    beforeEnter: guard(permissions.simulador)
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      title: 'Dashboard'
    },
    component: () => import(/* webpackChunkName: "Dashboard" */ '../pages/dashboard/Dashboard.vue'),
    beforeEnter: guard(permissions.dashboard)
  },
  {
    path: '/conta-azul-con',
    name: 'contaAzulCon',
    meta: {
      title: 'Conta Azul Con',
      public: true
    },
    component: () => import(/* webpackChunkName: "ContaAzulCon" */ '../pages/contaAzulCon/ContaAzulCon.vue')
  },
  {
    path: '/contaAzulCon',
    name: 'contaAzulcon',
    meta: {
      title: 'Conta Azul Con',
      public: true
    },
    component: () => import(/* webpackChunkName: "ContaAzulCon" */ '../pages/contaAzulCon/ContaAzulCon.vue')
  },
  {
    path: '/hiring',
    name: 'hiring',
    meta: {
      title: 'Hiring'
    },
    component: () => import(/* webpackChunkName: "Hiring" */ '../pages/hiring/Hiring.vue'),
    beforeEnter: guard(permissions.hiring)
  },
  {
    path: '*',
    name: 'not-found',
    meta: {
      title: 'Página não encontrada',
      public: true
    },
    component: () => import(/* webpackChunkName: "NotFound" */ '../pages/not-found/NotFound.vue')
  }
]

const router = new Router({
  mode: 'history',
  routes
})

// router.beforeEach((to, from, next) => {
//   document.title = 'SimplesHub | ' + to.meta.title
//   document.public = to.meta.public
//   // if (to.matched.some(record => !record.meta.public)) {
//   //   if (!firebase.auth().currentUser) {
//   //     next({ name: 'login' })
//   //   } else {
//   //     next()
//   //   }
//   // } else {
//   //   next()
//   // }
//   if (to.matched.some((record) => !record.meta.public)) {
//     if (!firebase.auth().currentUser) {
//       next({ name: 'login' })
//     } else {
//       next()
//     }
//   } else {
//     next()
//   }
//   // if (!window.uid && !to.meta.public) {
//   //   next({ name: 'login' })
//   // } else {
//   //   next()
//   // }
// })
router.beforeEach((to, from, next) => {
  document.title = 'HUBSTROM | ' + (to.meta.title || 'App')

  // Route requires auth if it's NOT explicitly public === true
  const requiresAuth = to.matched.some(r => r.meta && r.meta.public !== true)

  // If no auth needed, proceed
  if (!requiresAuth) return next()

  // If auth needed, check Firebase user
  const user = firebase.auth && firebase.auth().currentUser
  if (user) return next()

  // Not logged in -> send to login
  next({ name: 'login', query: { redirect: to.fullPath } })
})

export default router
